skrilla.controller('createLoLContestModalCtrl', function ($scope, searchService, cacheService, lolContestService, srefService, modalService, currencyService) {
    $scope.contest = cacheService.getObject("lolContest");
    $scope.contest.currency = "USD";
    $scope.selectedMatches = cacheService.getObject("lolContestMatches");
    $scope.selectedPlaceholders = cacheService.getObject("lolContestPlaceholders");
    $scope.contests = [];

    $scope.create = function(){
        if(lolContestService.confirmMatches($scope.selectedMatches)){
            modalService.confirm("Are you sure you'd like to create this contest?",function() {
                $scope.contest.entryFee = currencyService.multiply($scope.contest.entryFee, $scope.contest.currency);
                $scope.contest.splits.forEach(function(split){split.amount = currencyService.multiply(split.amount, $scope.contest.currency);});
                $scope.contest.prizePool = currencyService.multiply($scope.contest.prizePool, $scope.contest.currency);
                $scope.contest.matchIds = lolContestService.getMatchIds($scope.selectedMatches);
                $scope.contest.matchPlaceholderIds = $scope.selectedPlaceholders.map(function(placeholder){return placeholder.id});
                $scope.contest.players = null;
                $scope.contest.matches = null;
                searchService.post("lol/contests/daily", $scope.contest, "Contest Successfully Created!").then(function(response){
                        $scope.contest.entryFee = currencyService.divide($scope.contest.entryFee, $scope.contest.currency);
                        $scope.contest.splits.forEach(function(split){split.amount = currencyService.divide(split.amount, $scope.contest.currency);});
                        $scope.contest.prizePool = currencyService.divide($scope.contest.prizePool, $scope.contest.currency);
                        if($scope.createAnother === true){
                            $scope.contests.push({id: response.data, entryFee: currencyService.multiply($scope.contest.entryFee, $scope.contest.currency), currency:$scope.contest.currency});
                        }
                        else{
                            srefService.go("lolContests");
                            modalService.dismissAll();
                        }
                    },
                    function(response){
                        $scope.contest.entryFee = currencyService.divide($scope.contest.entryFee, $scope.contest.currency);
                        $scope.contest.splits.forEach(function(split){split.amount = currencyService.divide(split.amount, $scope.contest.currency);});
                        $scope.contest.prizePool = currencyService.divide($scope.contest.prizePool, $scope.contest.currency);
                    });
            });
        }
    }

    $scope.cancel = function(){
        if($scope.contests.length === 0) {
            modalService.dismissAll();
        }
        else {
            modalService.confirm("Are you sure you'd like to cancel?", function(){
                srefService.go("lolContests");
                modalService.dismissAll();
            });
        }
    }

});